module.exports = __webpack_public_path__ + "static/media/caros-italic.7ce5d287.woff2";